import { CourseRun } from "@/common/courseRun/types";
import { PAID_MODES } from "./constants";

export type CoursePriceAndCurrency = {
  price: number;
  currency: string;
};

export const getCoursePriceAndCurrency = (
  courseRun: CourseRun,
  currencyToFilter: string = "",
): CoursePriceAndCurrency => {
  let price = 0;
  let currency = "USD";

  courseRun?.seats?.forEach((seat) => {
    if (
      PAID_MODES.has(seat.type) &&
      (!currencyToFilter || seat.currencyId === currencyToFilter)
    ) {
      price = seat.price;
      currency = seat.currencyId ?? "USD";
    }
  });

  return { price, currency };
};

const getCoursePrice = (courseRun: CourseRun, currencyToFilter: string = "") =>
  getCoursePriceAndCurrency(courseRun, currencyToFilter).price;

export default getCoursePrice;
